// @ts-nocheck
import { Avatar, Badge, Box, Card, Divider, Group, SimpleGrid, Stack, Text, Title } from '@/components/ui';

export default function TypographyPage() {
  return (
    <Stack gap="xl">
      <Box>
        <Text gradient gradientVariant="primary" size="xl" fw={700}>
          Typography
        </Text>
        <Text c="dimmed" size="sm">
          Gradient text, avatars, dividers, and typography components
        </Text>
      </Box>

      {/* Gradient Text Sizes */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Text Sizes</Title>

          <Text gradient gradientVariant="primary" size="3rem" fw={800}>
            Extra Large Heading
          </Text>
          <Text gradient gradientVariant="secondary" size="2rem" fw={700}>
            Large Heading
          </Text>
          <Text gradient gradientVariant="tertiary" size="1.5rem" fw={600}>
            Medium Heading
          </Text>
          <Text gradient gradientVariant="primary" size="lg" fw={500}>
            Regular Text with Gradient
          </Text>
          <Text gradient gradientVariant="secondary" size="sm">
            Small text with gradient effect
          </Text>
        </Stack>
      </Card>

      {/* Animated Gradient Text */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Animated Gradient Text</Title>

          <Text gradient gradientVariant="primary" size="2rem" fw={700} animate>
            Animated Primary Gradient
          </Text>
          <Text gradient gradientVariant="secondary" size="xl" fw={600} animate>
            Animated Secondary Gradient
          </Text>
          <Text gradient gradientVariant="success" size="lg" fw={500} animate>
            Animated Success Gradient
          </Text>
        </Stack>
      </Card>

      {/* All Gradient Variants */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Variants</Title>

          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
            <Box>
              <Text gradient gradientVariant="primary" size="lg" fw={600}>
                Primary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="secondary" size="lg" fw={600}>
                Secondary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="tertiary" size="lg" fw={600}>
                Tertiary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="success" size="lg" fw={600}>
                Success Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="warning" size="lg" fw={600}>
                Warning Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="danger" size="lg" fw={600}>
                Danger Gradient
              </Text>
            </Box>
          </SimpleGrid>
        </Stack>
      </Card>

      {/* Gradient Dividers */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="lg">
          <Title order={4}>Gradient Dividers</Title>

          <Box>
            <Text size="sm" mb="xs">
              Primary (2px)
            </Text>
            <Divider gradientVariant="primary" thickness={2} />
          </Box>

          <Box>
            <Text size="sm" mb="xs">
              Secondary (3px)
            </Text>
            <Divider gradientVariant="secondary" thickness={3} />
          </Box>

          <Box>
            <Text size="sm" mb="xs">
              Tertiary (4px)
            </Text>
            <Divider gradientVariant="tertiary" thickness={4} />
          </Box>

          <Box>
            <Text size="sm" mb="xs">
              Animated Divider
            </Text>
            <Divider gradientVariant="primary" thickness={3} animated />
          </Box>
        </Stack>
      </Card>

      {/* Gradient Badges */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Badges</Title>

          <Group gap="sm">
            <Badge gradientVariant="primary" size="lg">
              Primary
            </Badge>
            <Badge gradientVariant="secondary" size="lg">
              Secondary
            </Badge>
            <Badge gradientVariant="tertiary" size="lg">
              Tertiary
            </Badge>
          </Group>

          <Group gap="sm">
            <Badge gradientVariant="success" size="md">
              Success
            </Badge>
            <Badge gradientVariant="info" size="md">
              Info
            </Badge>
            <Badge gradientVariant="warning" size="md">
              Warning
            </Badge>
            <Badge gradientVariant="danger" size="md">
              Danger
            </Badge>
          </Group>

          <Text size="sm" fw={500} mt="sm">
            Outlined Badges
          </Text>
          <Group gap="sm">
            <Badge gradientVariant="primary" outlined>
              Primary
            </Badge>
            <Badge gradientVariant="secondary" outlined>
              Secondary
            </Badge>
            <Badge gradientVariant="success" outlined>
              Success
            </Badge>
          </Group>
        </Stack>
      </Card>

      {/* Gradient Avatars */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Avatars</Title>

          <Group gap="xl">
            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="primary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png"
                size="lg"
              />
              <Text size="xs">Primary</Text>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="secondary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-2.png"
                size="lg"
              />
              <Text size="xs">Secondary</Text>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="tertiary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-3.png"
                size="lg"
              />
              <Text size="xs">Tertiary</Text>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="success"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-4.png"
                size="lg"
                borderWidth={4}
              />
              <Text size="xs">Success (4px)</Text>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="primary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-5.png"
                size="xl"
                animated
              />
              <Text size="xs">Animated</Text>
            </Stack>
          </Group>
        </Stack>
      </Card>
    </Stack>
  );
}
